export const SKIP_TEMPLATE_CONFIRM_PREFIX = 'template-confirm-skip';

// Template Grid Constants
export const TEMPLATE_GRID_CELL_THUMBNAIL_HEIGHT = 75;
export const TEMPLATE_GRID_CELL_THUMBNAIL_WIDTH = 150;
export const TEMPLATE_GRID_PADDING = 4;
export const TEMPLATE_GRID_CONTAINER_PADDING = 16;
export const TEMPLATE_GRID_ITEM_COUNT_PER_PAGE = 10;
export const TEMPLATE_GRID_COLUMN_COUNT = 2;